import { Observable } from 'rxjs';

import { EvaluationContent } from '../models/evaluation.model';
import { FileQueryParams, ResultQueryParams, ResultWithLatest } from '../models/result.model';

export abstract class ResultUsecase {
  abstract get resultWithLatests$(): Observable<ResultWithLatest[]>;

  abstract listResults(params: ResultQueryParams): Observable<never>;
  abstract getFile(params: FileQueryParams): Observable<string>;
  abstract getEvaluation(projectId: string, unitId: string, resultId: string): Observable<EvaluationContent[]>;

  abstract clearResults(): void;
}
